'use client'

import Button from '@/components/Button/Button'
import { Stack } from '@christiankaindl/lyts'
import Text from '@/components/Text/Text'
import Pill from '../Pill/Pill'
import { formatNumber } from '@/lib/utils'
import { useSearchResults, type SearchContextStore } from '../Search/SearchProvider'
import { Suspense, useState } from 'react'
import { documentTypeMappings } from '@/lib/search'

export function SidebarReferencesWithoutSuspense () {
  const results = useSearchResults()

  const [filters, setFilters] = useState<Awaited<SearchContextStore['results']>>()
  if (results && !filters) {
    setFilters(results)
  }

  return (
    <Suspense fallback={<div>Loading with use() ...</div>}>
      <Stack style={{ padding: '21px 9px' }} gap={0.5}>
        <Text style={{ paddingLeft: 12 }} size='small' color='tertiary' weight={600}>Rückverweise</Text>
        <Stack gap='1px'>
          {filters?.facet_counts?.[0].counts.map((facetCount) => {
            if (facetCount.value === 'law') return null

            return (
              <Button key={facetCount.value} variant='flat' href='#rueckverweise'>
                {documentTypeMappings[facetCount.value]} <Pill>{formatNumber(facetCount.count)}</Pill>
              </Button>
            )
          })}
        </Stack>
      </Stack>
    </Suspense>
  )
}

export default function SidebarReferences () {
  return (
    <Suspense fallback={null}>
      <SidebarReferencesWithoutSuspense />
    </Suspense>
  )
}
